import * as React from "react";
import {Alert, Card, Col, Form, Radio, Row, Spin, Tabs} from "antd";
import {CompanyItem, CompanyStore, CompanySummary} from "src/stores/companies-store";
import {CompanyFormBody} from "./company-change";
import FormEditorView from "../../../components/form-editor";
import {useTranslation, withTranslation, WithTranslation} from 'react-i18next'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import ContentTitle from 'src/core/ui/content-header';
import {formatMessage} from "../../../core/services/http.service";
import ProjectsList from 'src/pages/admin/projects/project-list';
import LogsList from 'src/pages/admin/logs/logs-list';
import EmployeesList from './employees/employee-list';
import ReportTabView from 'src/components/reports';
import {IdentityProps, withIdentity} from "src/core/services/authentication";
import {isNullOrUndefined} from "util";
import RestrictionPlansList from 'src/pages/admin/restriction-plan/restriction-plans-list';
import TemplatesTab from "../templates/templates-tab";
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import NewRestrictionPlanView from '../restriction-plan/restriction-plan-new';
import {NewRestrictionPlanItem} from "../../../../stores/restriction-plans-store";
import {navigate} from "../../../core/ui/link";
import {UserProfileProps, withUserProfile} from 'src/components/user-profile';
import {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import {checkAuthAdmin, checkAuthAdminFi, checkLogAuth, isReadOnly} from "../../../utils/CheckValidationbyUsers";
import {getCurrencySymbol} from "../../../utils/getSymbolCurrency";
import {compareObjectsGetDiferences} from "../../../utils/utils";
import { WrapperTimesheetTable } from "../timesheets/wrapper-timesheet-table";
import { WrapperEmployeeTable } from "./employees/WrapperEmployeeTable";


interface CompanyViewProps extends RouteComponentProps<{ companyId: string }>, UserProfileProps, IdentityProps {
    form: any
    tReady: boolean,
    getFieldDecorator: any,
    getFieldValue: any,
    companyStores: any,
    tabId: string | null
}

interface CompanyViewState {
    shouldEmployeeRefresh: boolean,
    shouldCompanyRefresh: boolean,
    shouldProjectRefresh: boolean,
    shouldTemplateRefresh: boolean,
    showRestrictionPlanCreationModal: boolean,
    loadingTab: boolean
    companyId: string,
}
const isTabAvilable = (tab: string | null): boolean => {
    return !isNullOrUndefined(tab) && ['general', 'employees', 'projects', 'timesheets', 'employeesManagement', 'projectsManagement', 'restrictionplans', 'templates', 'logs', 'reports'].includes(tab);
}

const companiesStore = new CompanyStore();
const CompanyView = (props: CompanyViewProps) => {
    const {userProfile} = props;
    const [showRestrictionPlanCreationModal, setShowRestrictionPlanCreationModal] = useState<boolean>(false);
    const [loadingTab, setLoadingTab] = useState<CompanyViewState['loadingTab']>(false);
    const [detailCompany, setDetailCompany] = useState<CompanyItem>()
    const [isError, setIsError] = useState(false)
    const [msgError, setMsgError] = useState()
    const search = props.location.search;
    let tab = new URLSearchParams(search).get('tab') ?? 'general';
    const history = useHistory();
    const {t, i18n} = useTranslation();

    useEffect(() => {
        load();
    }, [props.match.params.companyId, tab]);

    const openRestrictionPlanAddModal = () => {
        setShowRestrictionPlanCreationModal(true)
    }

    const onRestrictionPlanCreationModalClose = async (id: string | undefined, item: NewRestrictionPlanItem | undefined) => {
        setShowRestrictionPlanCreationModal(false)
        await load()
        if (detailCompany && id) {
            props.form.setFieldsValue({defaultRestrictionPlanId: id})
        }
    }

    const load = async () => {
        setLoadingTab(true)
        let resul = await companiesStore.getCompanyDetail(props.match.params.companyId);
        setDetailCompany(resul)
        setLoadingTab(false)
        return resul
    }

    const handleUpdateItem = async (values: any) => {
       
        
        if (detailCompany && values) {
            detailCompany.currency = detailCompany.currency ?? "EUR"
            if (values['tenantId']['label']) {
                if ( 'key' in values['tenantId'] && detailCompany.tenantId !== values['tenantId']['key'] || ('value' in values['tenantId'] && detailCompany.tenantId !== values['tenantId']['value']))
                    values['tenantName'] = values['tenantId']['label'][1]
                else
                    values['tenantName'] = values['tenantId']['label']
                values['tenantId'] = 'key' in values['tenantId'] ? values['tenantId']['key'] : values['tenantId']['value']
                detailCompany.tenantId = detailCompany?.tenantId ? detailCompany?.tenantId : ''
                detailCompany.tenantName = detailCompany?.tenantName ? detailCompany?.tenantName : ''
            }
            detailCompany.reference = detailCompany?.reference ? detailCompany?.reference : ''
           
            detailCompany.defaultRestrictionPlanId = detailCompany?.defaultRestrictionPlanId ? detailCompany?.defaultRestrictionPlanId : undefined
            let changes = compareObjectsGetDiferences(detailCompany, values)
            const result = await companiesStore.updateCompanyDetail(detailCompany.id, changes);
            result && result?.isSuccess && load()
            return result
        }
    }

    const onChangeTab = async (activeKey: string) => {
        history.push(`/time-tracking/admin/companies/${props.match.params.companyId}/?tab=${activeKey}`);
    }



    const renderLoading = (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <Spin size="large"/>
        </div>
    )

    return (
        <div>
            {detailCompany && <Row gutter={0}>
                <Col span={10}>
                    <ContentTitle type={t("Company")} title={detailCompany?.title}/>
                </Col>
                <Col span={14} style={{marginTop: 40}}>
                    <Radio.Group style={{float: 'right'}} value="companies-settings">
                        <Radio.Button value="companies-settings">{t('Companies Settings')}</Radio.Button>
                        {checkAuthAdminFi(userProfile) && <Radio.Button
                            value="app-settings"
                            onClick={() => navigate(history, `/time-tracking/admin/appsettings/`)}
                        >
                            {t('Application Settings')}
                        </Radio.Button>}
                        
                    </Radio.Group>
                </Col>
            </Row>}
            <Row type={'flex'} align='top' justify='space-between'>
                {isError && (
                    <Alert
                        type="error"
                        message={t("An error has occurred")}
                        description={t(formatMessage(msgError))}
                    />
                )}
                <Card data-tut="reactour__navegateCompany" style={{width: '100%', zIndex: 0}}>
                    {loadingTab && renderLoading}
                    {detailCompany?.id && !loadingTab && tab &&
                        <Tabs defaultActiveKey={isTabAvilable(tab) ? tab : 'general'} onChange={onChangeTab}>
                            <Tabs.TabPane key="general" tab={t("Company")}>
                                <FormEditorView
                                    dontShowErrors={true}
                                    onSaveItem={handleUpdateItem}
                                    onCancel={() => navigate(history, `/time-tracking/admin/companies/`)}
                                    showActions={(isReadOnly(userProfile)) ? "Never" : 'Always'}
                                    form={props.form}
                                    style={{maxWidth: 800}}
                                >
                                    <CompanyFormBody
                                        disabled={isReadOnly(userProfile)}
                                        openRestrictionPlanAddModal={openRestrictionPlanAddModal}
                                        userProfile={userProfile}
                                        i18n={i18n}
                                        t={t}
                                        tReady={props.tReady ? props.tReady : false}
                                        item={detailCompany}
                                        getFieldDecorator={props.form.getFieldDecorator}
                                        getFieldValue={props.form.getFieldValue}
                                    />
                                </FormEditorView>
                                {
                                    showRestrictionPlanCreationModal && (
                                        <NewRestrictionPlanView
                                            userProfile={userProfile}
                                            companyId={detailCompany.id}
                                            onClose={onRestrictionPlanCreationModalClose}
                                        />
                                    )
                                }
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="restrictionplans"
                                tab={
                                    <EditableTooltip name="company-detail-working-regimes">
                                        {t("Restriction Plans")}
                                    </EditableTooltip>}>
                                <RestrictionPlansList
                                    companyName={detailCompany.title}
                                    companyId={detailCompany.id}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane key="employees" tab={t("Employees")}>
                                <WrapperEmployeeTable
                                    handleLoading={setLoadingTab}
                                    companyName={detailCompany.title}
                                    allowCir={detailCompany.cirEligible}
                                    allowCii={detailCompany.ciiEligible}
                                    currency={getCurrencySymbol(detailCompany.currency ?? '')}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane key="projects" tab={t("Projects")}>
                                <div style={{position: 'relative'}}>
                                    <ProjectsList
                                        companyName={detailCompany.title}
                                        companyAllowCir={detailCompany.cirEligible}
                                        companyAllowCii={detailCompany.ciiEligible}
                                    />
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="timesheets"
                                tab={<EditableTooltip
                                    name="company-detail-timesheets"
                                >
                                    {t("Timesheets")}
                                </EditableTooltip>}>
                                <WrapperTimesheetTable
                                    companyId={detailCompany.id}
                                    companyName={detailCompany.title}
                                    item={detailCompany}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="reports"
                                tab={<EditableTooltip
                                    name="company-detail-reports">{t("Reports")} </EditableTooltip>}>
                                <ReportTabView
                                    companyName={detailCompany.title}
                                    companyId={detailCompany.id}
                                    isAdmin={true}
                                    currency={getCurrencySymbol(detailCompany.currency ?? '')}
                                    allowCir={detailCompany.cirEligible}
                                    allowCii={detailCompany.ciiEligible}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane key="templates" tab={<EditableTooltip
                                name="company-detail-templates">{t("Templates")} </EditableTooltip>}>
                                <TemplatesTab
                                    companyId={detailCompany.id}
                                    companyName={detailCompany.title}
                                    companyAllowCir={detailCompany.cirEligible}
                                    companyAllowCii={detailCompany.ciiEligible}/>
                            </Tabs.TabPane>

                            {checkLogAuth(userProfile) &&
                                <Tabs.TabPane
                                    key="logs"
                                    tab={<EditableTooltip
                                        name="company-detail-logs"
                                    >{t("Logs")} </EditableTooltip>}>
                                    <LogsList companyId={detailCompany.id}
                                              companyName={detailCompany.title}/>
                                </Tabs.TabPane>
                            }
                        </Tabs>}
                </Card>
            </Row>
        </div>
    )

}
// Wire up the React component to the Redux store
export default (withUserProfile(withIdentity(withRouter(withTranslation()(Form.create({})(CompanyView) as any) as any)) as any) as any) as React.ComponentClass<CompanyViewProps>;